export default __webpack_public_path__ + "static/media/nightsky.c7436a40.jpg";